import gql from 'graphql-tag';

/**
 * Data of the block project-power-company-communication ("EVU Kommunikation"): five dates, three
 * project numbers and the notes. Read through `Project.blocks.powerCompanyCommunication`, which
 * checks the block's read permission.
 */
export const PROJECT_POWER_COMPANY_COMMUNICATION_FIELDS = gql`
  fragment projectPowerCompanyCommunicationFields on ProjectPowerCompanyCommunicationBlock {
    id
    number
    netRegistrationSentAt
    operationRegistrationSentAt
    injectionConfirmationReceivedAt
    completionMessageSentAt
    powerCompanyClearanceAt
    powerCompanyProjectNumber
    powerCompanyProjectNumber2
    powerCompanyProjectNumber3
    powerCompanyDescription
  }
`;
